import usedBottle from '../assets/products/usedBottle.jpg';
import bottle05 from '../assets/products/bottle05.jpg';
import bottle15 from '../assets/products/bottle15.jpg';
import tap from '../assets/products/tap.jpeg';
import gripHandle from '../assets/products/gripHandle.jpeg';
import stand from '../assets/products/stand.jpg';
import pump from '../assets/products/pump.jpeg';

export const productsData = [
  {
    id: "1",
    name: "New 19L Bottle (2 refills free)",
    category: "bottles",
    price: 1500,
    stock: 30,
    description: "Refillable 19L water bottle for home/office use. Get two refills free with every new bottle purchase.",
    image: usedBottle
  },
  {
    id: "2",
    name: "0.5L PET Bottle",
    category: "pet_bottles",
    price: 350,
    stock: 500,
    description: "Small disposable PET bottle.",
    image: bottle05
  },
  {
    id: "3",
    name: "1.5L PET Bottle",
    category: "pet_bottles",
    price: 350,
    stock: 300,
    description: "Standard large PET bottle.",
    image: bottle15
  },
  {
    id: "4",
    name: "19L Bottle Refill at Shop",
    category: "Refill",
    price: 130,
    stock: 20,
    description: "Refill your 19L bottle at our shop.",
    image: usedBottle
  },
  {
    id: "5",
    name: "19L Bottle Refill with home delivery",
    category: "Refill",
    price: 160,
    stock: 20,
    description: "Refill your 19L bottle at our home.",
    image: usedBottle
  },
  {
    id: "6",
    name: "Bottle Stand",
    category: "accessories",
    price: 400,
    stock: 40,
    description: "Stand for 19L bottles.",
    image: stand
  },
  {
    id: "7",
    name: "Grip Handle",
    category: "accessories",
    price: 300,
    stock: 50,
    description: "Handle for easy carrying of 19L bottles.",
    image: gripHandle
  },
  {
    id: "8",
    name: "Tap",
    category: "accessories",
    price: 300,
    stock: 40,
    description: "Tap for 19L bottles.",
    image: tap
  },
  {
    id: "9",
    name: "T-Pump",
    category: "accessories",
    price: 1200,
    stock: 20,
    description: "T-Pump for 19L bottles.",
    image: pump
  }
];